import { color } from '@mui/system'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import InformacionGeneralFormComponent from './InformacionGeneralFormComponent';
import ValidacionDomicilioFormComponent from './ValidacionDomicilioFormComponent';
import TabsRecepcionMateriaPrimaComponent from './TabsRecepcionMateriaPrimaComponent';

function TabsInspeccionar(props) {


    const [tabUno, setTabUno] = React.useState(true)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)
    const [tabCinco, setTabCinco] = React.useState(false)
    const [tabSeis, setTabSeis] = React.useState(false)


    const dispatch = useDispatch()

    const irASeccion = () => {
        const element = document.getElementById('inicioTabs');

        if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };


    const setearValoresUno = () => {
        irASeccion()
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresDos = () => {
        irASeccion()
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresTres = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresCuatro = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true); setTabCinco(false); setTabSeis(false);
    }
    const setearValoresCinco = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(true); setTabSeis(false);
    }
    const setearValoresSeis = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(true);
    }

    return (
        <Fragment><br />
            <div className={`row text-center ${estilos.tabsSegundoNivel} mt-2`}>
                {/**OPCIONES NIVEL 2 */}
                <div className='row mt-2'>
                    <div className='col-3' >
                        <button onClick={() => setearValoresUno()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabUno ? '#68813B' : 'transparent', color: tabUno ? 'white' : 'black' }}>Información <br />General</button>
                    </div>
                    <div className='col-2'>
                        <button onClick={() => setearValoresDos()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabDos ? '#68813B' : 'transparent', color: tabDos ? 'white' : 'black' }}>Validación de <br />domicilio</button>

                    </div>
                    {
                        //verdaderaInstalacion.idtipoanexo === 2 ?
                        //    <div className='col-2'>
                        //        <button onClick={() => setearValoresSeis()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabSeis ? '#68813B' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Cumplimiento con NOM 070</button>
                        //
                        //    </div>
                        //    : <div />
                    }
                    {
                        props.tipo == 1 ? 
                        <div className='col-2'>
                        <button onClick={() => setearValoresTres()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabTres ? '#68813B' : 'transparent', color: tabTres ? 'white' : 'black' }}>Procesos <br />y Equipo</button>

                    </div>
                    :
                    <Fragment></Fragment>
                    }
                    {/* <div className='col-2'>
                        <button onClick={() => setearValoresCuatro()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCuatro ? '#68813B' : 'transparent', color: tabCuatro ? 'white' : 'black' }}>Foto<br></br>galería<br /></button>

                    </div>
                    <div className='col-3'>
                        <button onClick={() => setearValoresCinco()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabCinco ? '#68813B' : 'transparent', color: tabCinco ? 'white' : 'black' }}>Evaluación de <br></br>B.P.M</button>
                    </div> */}
                </div>


                {
                    tabUno ? (
                        <div className='row text-center'>
                            <InformacionGeneralFormComponent informe={props.informe} solicitud={props.solicitud} />
                            <div className="col mt-5 mb-3">
                            </div>
                            <div className="col mt-5 mb-3">
                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresDos()}>Ir a Validar domicilio<ArrowForwardIcon /></button>
                            </div>
                        </div>

                    ) :
                        tabDos ? (
                            <div className='row text-center'>
                                <ValidacionDomicilioFormComponent informe={props.informe} />
                                <div className="col">
                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresUno()}><ArrowBackIcon />Ir a Información General</button>
                                </div>
                                <div className="col">
                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresTres()}>Ir a Procesos y Equipo<ArrowForwardIcon /></button>
                                </div>
                            </div>

                        ) :
                            tabTres ? (
                                <div className='row text-center'>
                                    <TabsRecepcionMateriaPrimaComponent informe={props.informe} tipo={props.tipo} solicitud={props.solicitud} />
                                    <div className="col mt-5 mb-3">
                                        <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresDos()}><ArrowBackIcon />Ir a Validar domicilio</button>
                                    </div>
                                    <div className="col mt-5 mb-3">
                                        <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCuatro()}>Ir a Fotogaleria<ArrowForwardIcon /></button>
                                    </div>
                                </div>
                            ) :
                                tabCuatro ? (
                                    <div className='row text-center'>
                                        {
                                            // props.tipo === 2 ?
                                            //     <FotoGaleriaEnvasadoComponent informe={props.informe}></FotoGaleriaEnvasadoComponent>
                                            //     :
                                            //     props.tipo === 3 ?
                                            //         <FotoGaleriaAlmacenComponent informe={props.informe}></FotoGaleriaAlmacenComponent>
                                            //         :
                                            //         <FotoGaleriaComponent informe={props.informe}></FotoGaleriaComponent>

                                        }

                                        <div className="col mt-5 mb-3">
                                            <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresTres()}><ArrowBackIcon />Ir a Procesos y Equipo</button>
                                        </div>
                                        <div className="col mt-5 mb-3">
                                            <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCinco()}>Ir a Evaluación de Buenas Practicas de Manofactura<ArrowForwardIcon /></button>
                                        </div>
                                    </div>
                                ) :
                                    tabCinco ? (
                                        <div className='row text-center'>
                                            {/* <BuenasPracticasComponent informe={props.informe} tipo={props.tipo}></BuenasPracticasComponent> */}
                                            <div className="col mt-5 mb-3">
                                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCuatro()}><ArrowBackIcon />Ir a Fotogalería</button>
                                            </div>
                                            <div className="col mt-5 mb-3">
                                            </div>
                                            <div className="col mt-5 mb-3">
                                            </div>
                                        </div>

                                    ) :
                                        tabSeis ? (
                                            <div className='row text-center'>
                                                {/* <CuestionarioEnvasadoForm detalles={todo} instalacion={instalacion} idinforme={idinforme}></CuestionarioEnvasadoForm> */}
                                                <div className="col mt-5 mb-3">
                                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAMTab}`} onClick={() => setearValoresCinco()}><ArrowBackIcon />Ir a Fotogalería</button>
                                                </div>
                                                <div className="col mt-5 mb-3">
                                                </div>
                                                <div className="col mt-5 mb-3">
                                                </div>
                                            </div>

                                        ) :
                                            <div />

                }

            </div>

        </Fragment>
    );
};


export default withRouter(TabsInspeccionar)